 import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http, Response, Headers, RequestOptions, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Invoice, ProfileDetail } from '@externalusermodel/Invoice';
import { Station, AccountExecutives, ChaseUIDRequest, ChaseAdvancePaymentUIDRequest,StationList } from '@externalusermodel/AdvancePayment';
import { environment } from '@environment/environment';
import { AdvancePaymentDetails } from '@externalusermodel/AdvancePaymentDetails';
import { TransactionHistory, TransactionHistoryUpdate } from '@externalusermodel/Order';
import { ChaseProfileTransactionData } from '@externalusermodel/ChaseProfileTransactionData';
import { ChaseProfileTransactionDetails } from '@externalusermodel/ChaseProfileTransactionDetails';
import { AgencyDetail } from '@externalusermodel/AgencyDetail';
import { Options } from 'selenium-webdriver/opera';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class ExternalUserService {

    private baseUrl: string;
    amount: number;
    storedAccessJwtToken = sessionStorage.getItem('token');
    
    constructor(private http: Http) {
        this.baseUrl = environment.stage.Invoiceservicebaseurl;
    }
    // Method to get the invoice grid
    GetInvoiceGrid(agencyID): Observable<any[]> {
        const headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.storedAccessJwtToken}`})
            let options = { headers: headers };

        return this.http.get(this.baseUrl + `/api/Invoice/` + agencyID,options)
            .map(response => response.json())
            .catch(handleError);
    }
    // Get Order Grid data
    GetOrderGrid(agencyID): Observable<any[]> {
        return this.http.get(this.baseUrl + `/api/Order/` + agencyID)
            .map(response => response.json())
            .catch(handleError);
    }

    // Changed to POST Method - 28/09/2018
        GetInvoiceDetail(totalamount, agencyID,Paymenttype, chaseOrderId,history:any[]): Observable<any[]> {
        //debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.baseUrl + `/api/InvoiceCalc/` + totalamount + `/` + agencyID + `/` + Paymenttype + `/` + chaseOrderId, JSON.stringify(history), options)
       // return this.http.post(this.baseUrl + `/api/InvoiceCalc`, JSON.stringify(history))
            .map(response => response.json())
            .catch(handleError);
    }
    // Arvind changes for order id in order detail and changed to post method.
    GetOrderDiscountDetail(Ordertotalamount, agencyID, Tax, agencyComm,Paymenttype,orders): Observable<any[]> {
        debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.baseUrl + `/api/Order/PayAmountCalc/` + Ordertotalamount + `/` + agencyID + `/` + Tax + `/` + agencyComm + `/` + Paymenttype, JSON.stringify(orders), options)
            .map(response => response.json())
            .catch(handleError);
    }

    GetAdvanceDiscountDetail(Advancetotalamount): Observable<any> {
        return this.http.get(this.baseUrl + `/api/AdvanceCalc/` + Advancetotalamount )
            .map(response => response.json())
            .catch(handleError);
    }

    // Arvind Added for Advance page agency commission
   // GetAdvanceAgencyDetail(Advancetotalamount,agencyID,paymenttype,advancePaymentDetailsId,isTaxChecked): Observable<any>
    GetAdvanceAgencyDetail(Advancetotalamount,agencyID,paymenttype,advancePaymentDetailsId,isTaxChecked,isCommissionChecked): Observable<any> {
        return this.http.get(this.baseUrl + `/api/AdvanceCalc/` + Advancetotalamount + `/` + agencyID +`/` + paymenttype +`/` + advancePaymentDetailsId +`/` + isTaxChecked +`/` + isCommissionChecked)
            .map(response => response.json())
            .catch(handleError);
    }

    updateCommsandTaxPercent(paymenttype,advancePaymentDetailsId,isTaxChecked): Observable<any[]> {
        //debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        
        return this.http.post(this.baseUrl + `/api/updateCommsandTaxPercent/`+ paymenttype +`/` + advancePaymentDetailsId +`/` + isTaxChecked, JSON.stringify(advancePaymentDetailsId), options)
            .map(response => response.json())
            .catch(handleError);
    }

    updateCommsPercent(paymenttype,advancePaymentDetailsId): Observable<any[]> {
        //debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        
        return this.http.post(this.baseUrl + `/api/updateCommsPercent/`+ paymenttype +`/` + advancePaymentDetailsId, JSON.stringify(advancePaymentDetailsId), options)
            .map(response => response.json())
            .catch(handleError);
    }

    
     // Arvind Added for Advance page agency TAX
    //   GetAdvanceTaxDetail(isTaxChecked): Observable<any> {
    //      return this.http.get(this.baseUrl + `/api/AdvanceTaxCalc/` + isTaxChecked )
    //         .map(response => response.json())
    //          .catch(handleError);
    //  }

    // Method to get the Stations
    getStations() {
        const headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.storedAccessJwtToken}`})
            let options = { headers: headers };

        return this.http.get(this.baseUrl + `/api/AdvancePayments/Station`,options)
            .map(response => response.json() as Station[])
            .catch(handleError);
    }
    // Method to get the Stations
    getAccountExecutives() {
       
        const headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.storedAccessJwtToken}`})
            let options = { headers: headers };

        return this.http.get(this.baseUrl + `/api/AdvancePayments/AccountExecutives`, options)
            .map(response => response.json() as AccountExecutives[])
            .catch(handleError);
    }
    // Method to get order popup grid load


    GetOrderInvoiceGrid(orderInvoiceid, agencyID): Observable<any[]> {
        return this.http.get(this.baseUrl + `/api/OrderInvoice/` + agencyID + `/` + orderInvoiceid)
            .map(response => response.json())
            .catch(handleError);
    }
    getProfileList(UserID, Type) {
        return this.http.get(this.baseUrl + '/api/GetProfile/' + UserID + `/` + Type)
            .map(response => response.json() as ProfileDetail[])
            .catch(handleError);
    }

    saveAdvancePaymentDetails(advancePaymentDetailsId): Observable<number> {
        //debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.baseUrl + `/api/advancePayments/saveAdvancePaymentDetails`, JSON.stringify(advancePaymentDetailsId), options)
            .map(response => response.json())
            .catch(handleError);
    }

    getAdvancePaymentDetails(chaseOrderId: string): Observable<string> {
        // debugger;
        return this.http.get(this.baseUrl + `/api/getAdvancePaymentDetails/` + chaseOrderId)
            .map(response => response.json() as AdvancePaymentDetails)
            .catch(handleError);
    }

    // Chase methods



    saveTransactionHistory(transaction: TransactionHistory[]): Observable<string> {
        // debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let test = JSON.stringify(transaction);
        return this.http.post(this.baseUrl + `/api/Order/saveTransactionHistory`, JSON.stringify(transaction), options)
            .map(response => response.json())
            .catch(handleError);
    }

    getTransactionHistory(chaseOrderId: string): Observable<TransactionHistory[]> {
        return this.http.get(this.baseUrl + `/api/Order/getTransactionHistory/` + chaseOrderId)
            .map(response => response.json() as TransactionHistory[])
            .catch(handleError);
    }

    GetOrderUId(uIDRequestData: ChaseUIDRequest) {

        // debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.baseUrl + `/api/order/getUID`, JSON.stringify(uIDRequestData), options)
            .map(response => response.json())
            .catch(handleError);
    }


    ChaseProfileTransaction(transactionData: ChaseProfileTransactionData): Observable<any> {
        // debugger;
        const headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.storedAccessJwtToken}`})
            let options = { headers: headers };

           // headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        //let headers = new Headers({ 'Content-Type': 'application/json' });
       // let options = new RequestOptions({ headers: headers });

        return this.http.post(this.baseUrl + `/api/profile/profileTransaction`, JSON.stringify(transactionData), options)
            .map(response => response.json())
            .catch(handleError);
    }

    getTransactionDetailsFromChaseOrderId(chaseOrderId: string): Observable<ChaseProfileTransactionDetails> {
        // debugger;
        return this.http.get(this.baseUrl + `/api/profile/getTransactionDetailsFromChaseOrderId/` + chaseOrderId)
            .map(response => response.json());
    }

    updateTransactionHistory(requestData: TransactionHistoryUpdate): Observable<string> {
        // debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let test = JSON.stringify(requestData);
        return this.http.post(this.baseUrl + `/api/order/updateTransactionHistory`, JSON.stringify(requestData), options)
            .map(response => response.json())
            .catch(handleError);
    }

    getTransactionAmountFromChaseOrderId(chaseOrderId: string): Observable<string> {
        // debugger;
        return this.http.get(this.baseUrl + `/api/order/getTransactionAmountFromChaseOrderId/` + chaseOrderId)
            .map(response => response.json());
    }

    // Method to get the Agency List
    getAgencyList(UserID: any): Observable<any[]> {

        const headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.storedAccessJwtToken}`})
            let options = { headers: headers };
        return this.http.get(this.baseUrl + `/api/getAgencyList/` + UserID, options)
            .map(response => response.json() as AgencyDetail[])
            .catch(handleError);
    }

	getDownloadUrl(id: string): Observable<string> {
        //debugger;
        return this.http.get(this.baseUrl + `/api/aws/getDownloadUrl/` + id)
            .map(response => response.json());
    }

    SaveAdvancePaymentstations(AdvancePaymentstationsDetails: any): Observable<any[]> {
    //debugger;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.http.post(this.baseUrl + `/api/SaveAdvancePaymentstations`, JSON.stringify(AdvancePaymentstationsDetails), options)
      .map(response => response as any);
  }


   //Method to get the Station Grid
    GetStationGrid(UserID): Observable<any[]> {

        return this.http.get(this.baseUrl + `/api/GetAdvancePaymentStationList/` + UserID)
            .map(response => response.json() as StationList[])
            .catch(handleError);
    }



     UpdateAdvancePaymentstation(stationdetails: any): Observable<any[]> {
    //debugger;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.http.post(this.baseUrl + `/api/UpdateAdvancePaymentstations`, JSON.stringify(stationdetails), options)
      .map(response => response as any);
  }

   DeleteAdvancePaymentstation(stationdetails: any): Observable<any[]> {
    //debugger;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.http.post(this.baseUrl + `/api/DeleteAdvancePaymentstations`, JSON.stringify(stationdetails), options)
      .map(response => response as any);
  }

  getPayInformation(UserID) {

        return this.http.get(this.baseUrl + '/api/GetAdvancePayment/' + UserID)
            .map(response => response.json() )
            .catch(handleError);
    }


}
function handleError(error: any) {
    // log error
    // could be something more sofisticated
    let errorMsg = error.message || ``;
    console.error(errorMsg);

    // throw an application level error
    return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/external-user/Service/external-user.service.ts